/* MindPop Threads - accessibility fixes. Decorative icons are hidden from screen readers; icon-only buttons and embedded frames get names; footer headings and form labels are connected properly. */
(function () {
  function name(el, text) {
    if (!el.getAttribute('aria-label')) el.setAttribute('aria-label', text);
    if (!el.querySelector('.a11y-name')) {
      var s = document.createElement('span');
      s.className = 'visually-hidden a11y-name';
      s.textContent = text;
      el.appendChild(s);
    }
  }
  function fix(root) {
    if (!root.querySelectorAll) return;
    root.querySelectorAll('svg:not([aria-hidden]):not([role="img"]):not([aria-label])').forEach(function (s) {
      s.setAttribute('aria-hidden', 'true');
      s.setAttribute('focusable', 'false');
    });
    root.querySelectorAll('summary.main-menu-button').forEach(function (e) { name(e, 'Menu'); });
    root.querySelectorAll('.menu-drawer__back-button').forEach(function (e) { name(e, 'Back'); });
    root.querySelectorAll('button.drawer__outer-background').forEach(function (e) { name(e, 'Close menu'); });
    root.querySelectorAll('iframe:not([title])').forEach(function (f) {
      var id = f.id || '';
      f.setAttribute('title', id === 'merchantwidgetiframe' ? 'MindPop Threads videos' : id === 'PBarNextFrame' ? 'Shopify preview bar' : 'Embedded content');
    });
    /* Footer headings follow the page's level-2 headings, so mark them as level 2 (looks unchanged) */
    root.querySelectorAll('footer .footer__heading:not([aria-level])').forEach(function (h) {
      h.setAttribute('role', 'heading');
      h.setAttribute('aria-level', '2');
    });
    /* Country / language pickers: connect the visible label to its button */
    ['Country', 'Language'].forEach(function (kind) {
      var label = document.getElementById('Footer' + kind + 'Label');
      var btn = document.querySelector('[aria-controls="Footer' + kind + 'List"]');
      if (label && btn) {
        if (!btn.id) btn.id = 'Footer' + kind + 'Button';
        if (!label.getAttribute('for')) label.setAttribute('for', btn.id);
        btn.setAttribute('aria-labelledby', label.id + ' ' + btn.id);
        btn.removeAttribute('aria-describedby');
      }
    });
    /* Remove tooltips that just repeat the link text */
    root.querySelectorAll('a[title]').forEach(function (a) {
      if (a.getAttribute('title').trim().toLowerCase() === a.textContent.trim().toLowerCase()) a.removeAttribute('title');
    });
  }
  function start() {
    fix(document);
    new MutationObserver(function (list) {
      list.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1 && !(n.classList && n.classList.contains('a11y-name'))) fix(n.parentNode || n); }); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
